import { render, staticRenderFns } from "./PageBuild.vue?vue&type=template&id=899a2462&scoped=true"
import script from "./PageBuild.vue?vue&type=script&lang=js"
export * from "./PageBuild.vue?vue&type=script&lang=js"
import style0 from "./PageBuild.vue?vue&type=style&index=0&id=899a2462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899a2462",
  null
  
)

export default component.exports